<template>
  <div class="product-select">
    <van-checkbox-group v-model="result" @change="handleSelect">
      <van-cell-group>
        <van-cell
          v-for="(select, index) in selectList"
          :key="select.value"
          clickable
          :title="select.label"
          @click="toggle(index)"
          :style="{backgroundColor: result.indexOf(select.value) < 0 ? '#DDD': 'white'}">
          <template slot="label">
            <img :src="select.icon" class="select-icon">
            <van-checkbox :name="select.value" ref="checkboxes">
              <div slot="icon" slot-scope="props" class="circle-container" :style="{border: props.checked ? '1px solid #FA6400': ''}">
                <div class="circle" :style="{background: props.checked ? '#FA6400': ''}"></div>
              </div>
            </van-checkbox>
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'ProductSelect',
  data () {
    return {
      selectList: [
        {value: 1, label: 'MAXHUB\n会议平板', icon: require('@assets/images/home/icons/icon_huiyipingban.svg')},
        {value: 2, label: '5方MAXHUB\n云会议', icon: require('@assets/images/home/icons/icon_yunhuiyi.svg')},
        {value: 3, label: 'MAXHUB\nTeams', icon: require('@assets/images/home/icons/icon_teams.svg')},
      ],
      result: [1]
    }
  },
  methods: {
    toggle (index) {
      this.$refs.checkboxes[index].toggle();
    },
    handleSelect (newVal) {
      this.$emit('select', newVal);
    }
  }
}
</script>

<style lang="scss" scoped>
@import './ProductSelect.scss';
</style>